import '../kns.css';

function Header() {
  const handleNavClick = (e, targetId) => {
    e.preventDefault();
    const target = document.getElementById(targetId);
    if (target) {
      target.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <div className="main-header-container mainBg">
      <div className="row">
        <div className="col-md-4 col-xs-12 col-lg-4">
          <div className="kns-logo-container">
            <img className="kns-logo" src="kns-latest-1.webp" alt="KNS" />
            <h2 className="kns-header-fs">Logistics</h2>
          </div>
          <div className="kns-sub-heading">
          Preputial service
          <div className="loading-dots">
            <span className="dots"></span>
            <span className="dots"></span>
            <span className="dots"></span>
          </div>
          </div>
        </div>

        <div className="col-md-8 col-lg-8 col-xs-12 d-flex flex-column flex-md-row align-items-center justify-content-start">
          <div className="row">
            <div className="col-md-12 col-lg-12 col-xs-12">
              <div className="nav-wrapper">
                <a className="nav_link" href="#home" onClick={(e) => handleNavClick(e, 'home')}>Home</a>
                <a className="nav_link" href="#about" onClick={(e) => handleNavClick(e, 'about')}>About Us</a>
                <a className="nav_link" href="#services" onClick={(e) => handleNavClick(e, 'services')}>Services</a>
                <a className="nav_link" href="#contact" onClick={(e) => handleNavClick(e, 'contact')}>Contact Us</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Header;
